/* global G */
import { curry, deleteKey, setKey } from 'lib/util'
import { findGroup } from 'lib/util/attachment'

/**
 * Reset Message Event Handler
 *
 * Cancels the message field's edit mode.
 *
 * @param {Gaia.AppModule.Spec} module    the current module composition object
 * @param {Gaia.Component.Spec} component the message field component
 * @param {Gaia.PlatformEvent} event      the event that triggered this handler
 * @returns {Promise<void>}
 */
const reset = async (module, component, event) => {
  event?.preventDefault?.()
  event?.stopPropagation?.()

  const { [G.EVENTS]: eventBus } = module[G.ADAPTER]

  eventBus.dispatch(
    eventBus.type(G.ATTACHMENT, G.CACHE, findGroup(module, null, 'messageGroup')),
    { [G.DATA]: { [G.DATA]: [] } },
  )

  deleteKey('currentMessage', module[G.STATE])
  deleteKey('text', module[G.STATE])
  setKey(false, 'edit', module[G.STATE])

  if (component[G.STATE]) {
    setKey(false, 'edit', component[G.STATE])
    deleteKey('value', component[G.STATE])
  }

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(reset)
